import React, {useContext} from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import {AuthContext} from '../contexts/authContext';

/**
 * The session is backed by HttpOnly cookies, so the app cannot know locally
 * whether the user is logged in — it asks the backend (GET /auth/me, run by
 * AuthContext on boot). While that check is in flight we render nothing,
 * otherwise a logged-in user opening a link in a new tab (email links!) would
 * be bounced to /login before the cookie session has been recognized.
 */
const PrivateRoute = ({ children }) => {
  const { booted, user } = useContext(AuthContext);
  const location = useLocation();

  if (!booted) {
    return null;
  }

  if (user) {
    return children;
  }

  const loginPath = location.search
    ? `/login?returnUrl=${encodeURIComponent(location.pathname + location.search)}`
    : '/login';

  return <Navigate to={loginPath} />;
}

export default PrivateRoute;
